/**
 * Slidable
 * An element which can slide out to the right.
 * @version 1.0.1
 */



function Slideable( element ) {
	
	// ---------------------------------------
	// setup
	// ---------------------------------------
	
	let $app,
	
		minPosX,
		maxPosX,
	
		posX,
		touchStartX,
		touchMoveX,
		moveX,
		longTouch,
		triggerHappy;
	
	
	// ---------------------------------------
	// constructor
	// ---------------------------------------
	
	let init = function () {
		
		$app = $( element );
		
		let slideable = $app.get( 0 ),
			/* global Modernizr */ // TODO Modernize modernizer
			passive   = Modernizr.passiveeventlisteners
				? { passive: true }
				: false;
		
		slideable.addEventListener( 'touchstart', onTouchStartApp, passive );
		slideable.addEventListener( 'touchmove', onTouchMoveApp, passive );
		slideable.addEventListener( 'touchend', onTouchEndApp, passive );
		
		setSizes();
		
		$( window ).on( 'resize', onResizeWindow );
	};
	
	
	// ---------------------------------------
	// event handlers
	// ---------------------------------------
	
	/**
	 * Triggers when the user starts a touch.
	 * @void
	 */
	let onTouchStartApp = function ( event ) {
		
		// check if flick or long-touch.
		longTouch    = false;
		triggerHappy = false;
		
		setTimeout( function () {
			longTouch = true;
			
			// touch is active, prepare for touch-move to be instant
			$app.addClass( 'touch-active' );
		}, 200 );
		
		touchStartX = event.touches[ 0 ].pageX;
	};
	
	/**
	 * Triggers when the user moves after a touch.
	 * @void
	 */
	let onTouchMoveApp = function () {
		
		touchMoveX = event.touches[ 0 ].pageX;
		moveX      = -( touchStartX - touchMoveX );
		
		setPos( moveX );
	};
	
	/**
	 * Triggers when the user ends his touch.
	 * @void
	 */
	let onTouchEndApp = function ( event ) {
		
		$app.removeClass( 'touch-active' );
		
		let slideOutLimit = ( longTouch )
			? 60
			: 20;
		
		if ( moveX > slideOutLimit ) {
			// slide element out
			triggerHappy = true;
			setPos( maxPosX );
		} else {
			// return element to start
			setPos( minPosX );
		}
	};
	
	/**
	 * Triggers when the window resizes
	 * @void
	 */
	let onResizeWindow = function () {
		setSizes();
	};
	
	/**
	 * Triggers when a slide-out animation ends.
	 * @void
	 */
	let onTransitionEndApp = function () {
		$app.trigger( 'slid' );
	};
	
	
	// ---------------------------------------
	// public functions
	// ---------------------------------------
	
	// ---------------------------------------
	// private functions
	// ---------------------------------------
	
	/**
	 * Set size variables for the app.
	 * @void
	 */
	let setSizes = function () {
		
		minPosX = 0;
		maxPosX = screen.width;
	};
	
	/**
	 * Set the position of the slidable element.
	 * @void
	 */
	let setPos = function ( offset ) {
		
		offset = offset || 0;
		
		// make sure pos is within bounds, and request the slidable to move.
		if ( !isNaN( offset ) ) {
			posX = +Math.min( Math.max( offset, minPosX ), maxPosX ) + 'px';
			window.requestAnimationFrame( positionSlider );
		}
	};
	
	/**
	 * Moves the slider to a new position.
	 * @void
	 */
	let positionSlider = function () {
		
		if ( triggerHappy ) {
			triggerHappy = false;
			$app.one( 'transitionend', onTransitionEndApp );
		}
		
		$app.css( {
			'transform': 'translate3d( %s, 0, 0 )'.replace( '%s', posX ),
			'opacity'  : 1,
		} );
	};
	
	
	init();
	return this;
}

export default Slideable;